export const VIDEO_GETTER_VIDEO_URL = 'video/getter/videoUrl';
export const VIDEO_GETTER_FULL_FILE = 'video/getter/fullFile';
export const VIDEO_GETTER_SUBTITLE = 'video/getter/subtitle';

export const VIDEO_MUTATION_SET_VIDEO_URL = 'video/mutation/SET_VIDEO_URL';
export const VIDEO_MUTATION_SET_FULL_FILE = 'video/mutation/SET_FULL_FILE';
export const VIDEO_MUTATION_SET_SUBTITLE = 'video/mutation/SET_SUBTITLE';